import { Box, CloseButton, Dialog, HStack, Image, Link, Portal, Text } from "@chakra-ui/react";
import { FaWhatsapp } from "react-icons/fa";
import dayjs from "dayjs";
import { useState } from "react";

const URL_REGEX = /(https?:\/\/[^\s]+)/g;

const renderTextWithLinks = (text) => {
    const parts = text.split(URL_REGEX);
    return (
        <Text fontSize={15} whiteSpace="pre-wrap" color={'white'}>
            {parts.map((part, i) =>
                URL_REGEX.test(part)
                    ? <Link key={i} href={part} color="blue.200" target="_blank" rel="noopener noreferrer" wordBreak="break-all">{part}</Link>
                    : part
            )}
        </Text>
    );
};

const ChatBubble = ({ message }) => {
    const isOwner = message.user === "user" || message.source === "whatsapp";
    const [isOpen, setIsOpen] = useState(false);

    const renderMessageContent = () => {
        if (message.type === 'image' && message.content) {
            return (
                <Dialog.Root lazyMount open={isOpen} onOpenChange={(e) => setIsOpen(e.open)} placement={'center'}>
                    <Dialog.Trigger asChild>
                        <Image
                            src={message.source === 'whatsapp' ? message.content : message.content}
                            alt={message.filename}
                            maxW="100%"
                            borderRadius={6}
                            cursor={'pointer'}
                        />
                    </Dialog.Trigger>
                    <Portal>
                        <Dialog.Backdrop />
                        <Dialog.Positioner>
                            <Dialog.Content maxWidth="4xl">
                                <Dialog.Body p={0}>
                                    <Image src={message.source === 'whatsapp' ? message.content : message.content} w="100%" h="auto" />
                                </Dialog.Body>
                                <Dialog.CloseTrigger asChild>
                                    <CloseButton size="lg" top="2" right="2" position="absolute" color={'white'} />
                                </Dialog.CloseTrigger>
                            </Dialog.Content>
                        </Dialog.Positioner>
                    </Portal>
                </Dialog.Root>
            );
        }

        if (message.type === 'audio' && message.content) {
            return (
                <Box>
                    <audio controls src={message.source === 'whatsapp' ? message.content : message.content} style={{ maxWidth: '100%' }} />
                    {message.text && <Text fontSize={12} color={'whiteAlpha.700'} mt={1}>{message.text}</Text>}
                </Box>
            );
        }

        if (message.type === 'video' && message.content) {
            return (
                <Box>
                    <video controls src={message.source === 'whatsapp' ? message.content : message.content} style={{ maxWidth: '100%', borderRadius: 6 }} />
                    {message.text && <Text fontSize={12} color={'whiteAlpha.700'} mt={1}>{message.text}</Text>}
                </Box>
            );
        }

        if ((message.type === 'document' || message.type === 'file') && message.filename) {
            return (
                <Box>
                    <Text
                        as="a"
                        src={(message.source === 'whatsapp' ? message.content : message.content) ?? undefined}
                        download={message.filename}
                        fontSize={15}
                        color={'white'}
                        textDecoration={message.content ? 'underline' : 'none'}
                        cursor={message.content ? 'pointer' : 'default'}
                    >
                        {message.filename}
                    </Text>
                    {message.text && message.text !== message.filename &&
                        <Text fontSize={12} color={'whiteAlpha.700'} mt={1}>{message.text}</Text>}
                </Box>
            );
        }

        if (message.text) {
            return renderTextWithLinks(message.text);
        }

        return null;
    }

    return (
        <HStack w={'full'} alignItems={'flex-end'} justifyContent={'flex-end'}
            flexDirection={isOwner ? 'row' : 'row-reverse'} py={1}>
            <Text fontSize={11} color={'text.chatDate'}>{dayjs(new Date(message.timestamp)).format('HH:mm')}</Text>
            <Box maxW={'57%'} bg={isOwner ? 'bg.chatOwner' : 'bg.chatBot'} borderRadius={12}
                borderBottomEndRadius={isOwner ? 0 : 12} borderBottomLeftRadius={isOwner ? 12 : 0}
                pl={message.type === 'image' ? 2 : 4}
                pr={message.type === 'image' ? 2 : 4}
                pt={message.type === 'image' ? 2 : 3}
                pb={message.type === 'image' ? 2 : 3}
            >
                {message.source === 'whatsapp' && (
                    <HStack mb={1} gap={1}>
                        <FaWhatsapp color="#25D366" size={12} />
                        <Text fontSize="10px" color="#25D366">WhatsApp</Text>
                    </HStack>
                )}
                {renderMessageContent()}
            </Box>
        </HStack>
    )
}

export default ChatBubble;